"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var AGgrid_table_component_1 = require("../../../../../common/tables/AGgrid_table_component");
var route_path_1 = require("../../../../../constants/route_path");
var table_data_1 = require("../../../../../constants/table_data");
var approvals_helper_1 = require("../approvals_helper");
var react_redux_1 = require("react-redux");
var react_query_1 = require("react-query");
var react_paginate_1 = require("../../../../../common/react_pagination/react_paginate");
require("../approval.scss");
var LevelOneCashDeltionApprovalList = function (_a) {
    var searchTerm = _a.searchTerm, isFilterButton = _a.isFilterButton, PageLimit = _a.PageLimit;
    var nav = (0, react_router_1.useNavigate)();
    var approval_status = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList.approval_status; });
    var approval_types = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList.approval_types; });
    var pathname = (0, react_router_1.useLocation)().pathname;
    var _b = React.useState(), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = React.useState(undefined), pendingList = _c[0], setPendingList = _c[1];
    var _d = React.useState(1), pageCount = _d[0], setpageCount = _d[1];
    var _e = React.useState(0), totalPageCount = _e[0], setTotalPageCount = _e[1];
    var _f = React.useState(0), totalCount = _f[0], setTotalCount = _f[1];
    var onRowClickedHandler = function (event) {
        if (pathname.includes(route_path_1.default.PATHS.approvals)) {
            nav("/".concat(route_path_1.default.PATHS.approvals, "/").concat(route_path_1.default.PATHS.cashDeletion, "/").concat(route_path_1.default.PATHS.cashDeletionLevelTwoDetails), { state: event.data });
        }
    };
    var refetch = (0, react_query_1.useQuery)(['cash-deletion-level-one', pageCount], function () {
        var approvaltype = approval_types === null || approval_types === void 0 ? void 0 : approval_types.find(function (type) { return type.label === 'CASH_ENTRY_DELETION'; });
        var approvalStatus = approval_status === null || approval_status === void 0 ? void 0 : approval_status.find(function (type) { return type.label === 'PENDING_LEVEL_TWO'; });
        var currentPage = pageCount < 1 ? 1 : pageCount;
        var queryParam = "page=".concat(currentPage, "&size=").concat(PageLimit ? parseInt(PageLimit.value.toString()) : 50);
        if (approvaltype) {
            queryParam = queryParam + "&type=".concat(approvaltype.id);
        }
        if (approvalStatus) {
            queryParam = queryParam + "&status=".concat(approvalStatus.id);
        }
        if (searchTerm.trim()) {
            queryParam = queryParam + "&mobile=".concat(searchTerm);
        }
        (0, approvals_helper_1.cashDeletionApprovalList)(queryParam)
            .then(function (response) {
            var _a, _b;
            var updatedApprovalList = (0, approvals_helper_1.convertCashDeletionApprovalList)(response.result);
            setPendingList(updatedApprovalList);
            setErrorMessage('');
            var pageSize = PageLimit
                ? parseInt(PageLimit.value.toString())
                : 50;
            var count = Math.ceil(((_a = response.data) === null || _a === void 0 ? void 0 : _a.count) / pageSize);
            setTotalPageCount(count);
            setTotalCount((_b = response.data) === null || _b === void 0 ? void 0 : _b.count);
        })
            .catch(function (err) {
            setErrorMessage(err.message);
            setPendingList([]);
        });
    }).refetch;
    var handlePageClick = function (data) {
        var currentPage = data.selected + 1;
        setpageCount(currentPage);
    };
    var FilterHandler = function () {
        if (pageCount != 1) {
            setpageCount(1);
        }
        else {
            refetch();
        }
    };
    React.useEffect(function () {
        FilterHandler();
    }, [isFilterButton]);
    return (React.createElement("div", { className: "fe-wrapper custom-table custom-pagination-table ".concat(pathname.includes(route_path_1.default.PATHS.approvals)
            ? 'clickable-row'
            : 'unclickablerow') },
        React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: table_data_1.default.CASH_PENDING_APPROVAL_COLUMNS, rows: pendingList, errorMessage: errorMessage, onRowClicked: onRowClickedHandler, pagination: false, className: 'approvals-table' }),
        React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: pendingList === null || pendingList === void 0 ? void 0 : pendingList.length, currentPageLimits: PageLimit === null || PageLimit === void 0 ? void 0 : PageLimit.value })));
};
exports.default = LevelOneCashDeltionApprovalList;
